import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

const CarHuddleInsuranceHowItWorks = ({ pendingQuestionsStepsData = {}, completedQuestionsStepsData = {}, isInsuranceSubmitted }) => {
    const selectedStepsData = isInsuranceSubmitted ? completedQuestionsStepsData : pendingQuestionsStepsData;
    const { steps = [], title = "" } = selectedStepsData || {};

    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.headerWrap"}>
                <p styleName={"styles.heading"}>{title}</p>
            </div>

            <div styleName={"styles.nextStepWrap"}>
                {steps.map((step, index) => (
                    <div key={index} className="media" styleName={"styles.stepWrapper"}>
                        <p styleName={"styles.stepCount"}>{index + 1}</p>
                        <div className="media-body">
                            <p styleName={"styles.stepHead"}>{step.title}</p>
                            {step.subtext && <p styleName={"styles.refundSticker"}>{step.subtext}</p>}
                            {step.description && <p styleName={"styles.completeApplication"}>{step.description}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

CarHuddleInsuranceHowItWorks.propTypes = {
    pendingQuestionsStepsData: PropTypes.object,
    completedQuestionsStepsData: PropTypes.object,
    insuranceDetailsData: PropTypes.object,
    isInsuranceSubmitted: PropTypes.bool
};

export default CarHuddleInsuranceHowItWorks;
